import { DataTableConsumer } from '@/components/ui/data-table/types';
import { checklistsTableConfig } from '@/config/table-configs';
import {
  EntityListTable,
  type EntityListTableConfig,
} from '@/features/lists/components/EntityListTable';
import { checklistTagKeys } from '@/features/lists/components/ListTagsField';
import { listFields } from '@/features/lists/lists.fields';
import { useCurrentUser } from '@/features/users/users.hooks';
import { ListSummary } from '@certhon/models';
import { useMemo } from 'react';
import { getChecklistActions } from './checklists.actions';

const defaultFilter = 'status is: "open"';

function useChecklistRowActions() {
  const currentUser = useCurrentUser();
  return useMemo(
    () => getChecklistActions(currentUser?.recnum ?? null),
    [currentUser],
  );
}

export function ChecklistTable({
  uriPrefix = '',
  data,
  isLoading,
}: {
  uriPrefix?: string;
} & DataTableConsumer<ListSummary>) {
  const config = useMemo<EntityListTableConfig<ListSummary>>(
    () => ({
      tableId: 'checklists',
      fields: listFields,
      defaultColumnConfig: checklistsTableConfig,
      tagKeys: checklistTagKeys,
      defaultFilter,
      statePrefix: 'cl.',
      rowToHref: (list) => [uriPrefix, '/lists/', list.id].join(''),
      addPath: `${uriPrefix}/lists/new`,
      useRowActions: useChecklistRowActions,
      entityName: 'lists',
    }),
    [uriPrefix],
  );

  return (
    <EntityListTable<ListSummary>
      config={config}
      data={data}
      isLoading={isLoading}
    />
  );
}
